import { useState } from 'react';
import { popSheet, SheetNames } from '.';

export const selectSheetViewModel = ({
  sheetName,
  initialShow = true,
  api,
}: {
  sheetName: SheetNames;
  initialShow?: boolean;
  api?: {
    onClose?: (...args: any) => void;
    onCancel?: () => void;
  };
}) => {
  const [show, setShow] = useState<boolean>(initialShow);

  const cancel = () => {
    setShow(false);
    api?.onCancel?.();

    setTimeout(() => {
      sheetName && popSheet(sheetName);
    }, 250);
  };

  const close = (...args: any) => {
    setShow(false);
    api?.onClose?.(...args);

    setTimeout(() => {
      sheetName && popSheet(sheetName);
    }, 250);
  };

  return {
    api: {
      show: () => {
        setShow(true);
      },
      hide: () => {
        setShow(false);
      },
      onOpenChange: (open: boolean) => {
        if (!open) {
          cancel();
        }
      },
      cancel,
      close,
    },
    data: {
      show,
    },
  };
};
export type SheetViewModel = ReturnType<typeof selectSheetViewModel>;
